import React from "react";
import createIcon from "./utils";

export default createIcon(
	<svg viewBox="0 96 960 960" fill="currentColor">
		<path d="m296 722 122-122 80 80 152-151v77h60V426H530v60h77L498 595l-80-80-164 165 42 42ZM180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600V276H180v600Zm0-600v600-600Z" />
	</svg>,
	"ChartData"
);
